import * as yup from 'yup';

const presetItemSchema = yup.object().shape({
  amount: yup
    .string()
    .required('Обязательно для заполнения')
    .matches(/^[-+]?(?:\d+(?:\.\d+)?|\.\d+)$/, {
      message: 'Введите корректное число',
      excludeEmptyString: true,
    })
    .test('more-than-zero', 'Значение должно быть больше нуля', (value) => {
      if (!value) {
        return true;
      }

      return Number(value) > 0;
    }),
  description: yup
    .string()
    .nullable()
    .max(200, 'Это значение слишком длинное. Оно должно содержать 200 символов или меньше.'),
});

function uniqueAmountsTest(this: yup.TestContext, value: unknown): boolean | yup.ValidationError {
  if (!Array.isArray(value)) {
    return true;
  }
  const items = value as { amount?: string }[];
  const errors: yup.ValidationError[] = [];
  items.forEach((item, idx) => {
    if (!item.amount) {
      return;
    }
    const isDuplicate = items.some(
      (other, otherIdx) => otherIdx !== idx && other.amount === item.amount,
    );
    if (isDuplicate) {
      errors.push(
        this.createError({
          path: `${this.path}.${idx}.amount`,
          message: 'Сумма уже используется в другом пресете',
        }),
      );
    }
  });
  if (errors.length) {
    return new yup.ValidationError(errors);
  }
  return true;
}

const paymentCommentSchema = yup
  .string()
  .nullable()
  .max(200, 'Это значение слишком длинное. Оно должно содержать 200 символов или меньше.');

export const PRESETS_CREATE_SCHEMA = yup.object().shape({
  merchant: yup.string().required('Обязательно для заполнения'),
  gateway: yup.string().required('Обязательно для заполнения'),
  currency: yup.string().required('Обязательно для заполнения'),
  paymentComment: paymentCommentSchema,
  paymentItems: yup.array().of(presetItemSchema).test('unique-amounts', '', uniqueAmountsTest),
  payoutItems: yup.array().of(presetItemSchema).test('unique-amounts', '', uniqueAmountsTest),
});

export const PRESETS_EDIT_ITEMS_SCHEMA = yup.object().shape({
  items: yup.array().of(presetItemSchema).test('unique-amounts', '', uniqueAmountsTest),
});

export const PRESETS_EDIT_GENERAL_SCHEMA = yup.object().shape({
  currency: yup.string().required('Обязательно для заполнения'),
  paymentComment: paymentCommentSchema,
});
